import React from 'react';
import { Box } from 'native-base';
import HeaderNav from '../HeaderNav/HeaderNav';
import { useNavigate } from 'react-router-dom';

const DASHBOARD_HEADER_LINKS = [
  { label: 'Home', href: '/' },
  { label: 'Account', href: '/settings/personal-info' },
  { label: 'Support', href: 'mailto:support@ayblehealth.com' },
];

export const UserDashboardHeader = ({ prevRoute = '/' }) => {
  const navigate = useNavigate();

  const goBack = () => navigate(prevRoute);

  return (
    <Box pb={6} backgroundColor="secondary.500">
      <HeaderNav
        page={1}
        changePage={goBack}
        pageLinks={DASHBOARD_HEADER_LINKS}
      />
    </Box>
  );
};
